import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { Accordion } from '@platform-ui/design-system';
import { DSAccordions } from './Accordions';
import { ReplaySubject } from 'rxjs';
/* Special Snowflake: This is a blend of the ParentElement and ChildElement abstracts. */

export var DSAccordion = /*#__PURE__*/function (_HTMLElement) {
  _inherits(DSAccordion, _HTMLElement);

  var _super = _createSuper(DSAccordion);

  function DSAccordion() {
    var _this;

    _classCallCheck(this, DSAccordion);

    _this = _super.call(this); // @ts-ignore

    _defineProperty(_assertThisInitialized(_this), "elem", void 0);

    _defineProperty(_assertThisInitialized(_this), "parent", void 0);

    _defineProperty(_assertThisInitialized(_this), "header$", new ReplaySubject());

    _defineProperty(_assertThisInitialized(_this), "body$", new ReplaySubject());

    _defineProperty(_assertThisInitialized(_this), "footer$", new ReplaySubject());

    _defineProperty(_assertThisInitialized(_this), "props", {
      getHeaderSlot: function getHeaderSlot(node) {
        _this.header$.next(node);
      },
      getBodySlot: function getBodySlot(node) {
        _this.body$.next(node);
      },
      getFooterSlot: function getFooterSlot(node) {
        _this.footer$.next(node);
      }
    });

    var propKeys = ['key'].concat(_toConsumableArray(Object.keys(Accordion.__docgenInfo.props)));
    propKeys.map(function (prop) {
      Object.defineProperty(_assertThisInitialized(_this), prop, {
        get: function get() {
          return this.props[prop];
        },
        set: function set(newValue) {
          this.props[prop] = newValue;
          this.render();
        }
      });
    });
    return _this;
  }

  _createClass(DSAccordion, [{
    key: "render",
    value: function render() {
      this.elem = /*#__PURE__*/React.createElement(Accordion, this.props);
      this.parentElement.render();
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.render();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      delete this.elem;

      if (this.parentElement instanceof DSAccordions) {
        this.parentElement.render();
      }

      if (!document.body.contains(this)) {
        this.header$.next('unmount');
        this.body$.next('unmount');
        this.footer$.next('unmount');
      }
    }
  }]);

  return DSAccordion;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
//# sourceMappingURL=Accordion.js.map